import { render, staticRenderFns } from "./average-duration-by-device.vue?vue&type=template&id=0bc48900&scoped=true&"
import script from "./average-duration-by-device.vue?vue&type=script&lang=js&"
export * from "./average-duration-by-device.vue?vue&type=script&lang=js&"
import style0 from "./average-duration-by-device.vue?vue&type=style&index=0&id=0bc48900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc48900",
  null
  
)

component.options.__file = "average-duration-by-device.vue"
export default component.exports